import { composeIO } from 'react-compose-io'
import { parametrosRepasseIO } from './ParametrosRepasse.IO'
import ParametrosRepasseView from './ParametrosRepasse.View'

export const ParametrosRepasse = composeIO(ParametrosRepasseView, parametrosRepasseIO)
